'use strict';

import React, { Component } from 'react';
import classNames from 'classnames';

class MapSearch extends Component {
  constructor(props) {
    super(props);

    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.getCoordinatesFromGoogle = this.getCoordinatesFromGoogle.bind(this);

    this.state = {
      btnReset: ''
    };
  }

  handleSearchSubmit(e) {
    e.preventDefault();

    if (!this.props.mapApiRef) {
      console.log('----- Not able to retieve geolocations from Google -----');
      return;
    }

    const locationEntered = e.target.elements['map-search__input'].value;

    this.getCoordinatesFromGoogle(locationEntered);
  }

  handleInputChange(e) {
    const str = e.target.value;
    const inputEle = document.getElementById('map-search__input');
    const getCoordinatesFromGoogleRef = this.getCoordinatesFromGoogle;
    if (e.target.value.length >= 1) {
      this.setState({
        'btnReset': 'active'
      });
    } else {
      this.setState({
        'btnReset': ''
      });
    }
    if (e.target.value.length >= 3) {
      const t = setTimeout(() => {
        const autocomplete = new this.props.mapApiRef.places.Autocomplete((inputEle), {
          types: ['(cities)'],
          componentRestrictions: {
            country: 'AU'
          }
        });

        this.props.mapApiRef.event.addListener(autocomplete, 'place_changed', function () {
          getCoordinatesFromGoogleRef(inputEle.value);
        });
      }, 500);
    }

  }

  handleResetClick(e) {
    this.setState({
      'btnReset': ''
    });
  }

  getCoordinatesFromGoogle(location) {
    if (!this.props.mapApiRef) {
      console.log('----- Not able to retieve geolocations from Google -----');
      return;
    }

    const geo = new this.props.mapApiRef.Geocoder();
    geo.geocode(
      {
        address: `${location} NSW`,
        region: 'AU',
      },
      response => {
        const loc = response[0].geometry.location;

        if (loc.lat() && loc.lng()) {
          this.props.handleSearch({
            lat: loc.lat(),
            lng: loc.lng(),
          });
        }
      },
    );
  }

  render() {

    const btnResetClasses = classNames('', {
      'btn--active': this.state.btnReset === 'active'
    });
    return (
      <div className="map-search">
        <form onSubmit={this.handleSearchSubmit}>
          <label className="sr-only" htmlFor="map-search__input">Go to (suburb or postcode):</label>

          <input
            type="text"
            name="map-search__input"
            id="map-search__input"
            placeholder="Search for suburb or postcode"
            onChange={this.handleInputChange}
            autoComplete="off"
          />
          <button type="submit">Search</button>
          <button
            type="reset"
            className={btnResetClasses}
            onClick={this.handleResetClick}
          >
            Reset
            <span className="sr-only">Close search bar</span>
          </button>
        </form>
      </div>
    );
  }
}

export default MapSearch;
